import { render, staticRenderFns } from "./Nomina.vue?vue&type=template&id=6d3aa854&scoped=true&"
import script from "./Nomina.vue?vue&type=script&lang=js&"
export * from "./Nomina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3aa854",
  null
  
)

export default component.exports